export const graphCardtexts = (data) => [
  {
    title: "1mregistered",
    date: data?.BeanMonth || "0",
    description: "unit",
  },
  {
    title: "registeredcount",
    date: data?.BeanCount || "0",
    description: "unit",
  },
  {
    title: "1manalyses",
    date: data?.AnalysisOneMonth || "0",
    description: "unit",
  },
  {
    title: "6manalyses",
    date: data?.AnalysisSixMonth || "0",
    description: "unit",
  },
  {
    title: "analysescount",
    date: data?.AnalysisTotalCount || "0",
    description: "unit",
  },
  {
    title: "recentlyproducedcount",
    date: data?.CoffeeCount || "0",
    description: "unit",
  },
];
